import superagent from 'superagent';

export function getCities() {
  return superagent.get('/order/cities').then(res => res.body);
}

export function urlFromName(name) {
  return `/alcohol-delivery-${slugFromName(name)}`;
}

function slugFromName(name = '') {
  return name.toLowerCase().replace(/[^\w]+/g, '-');
}

export function sanitizeCity(city = {}) {
  return { ...city, slug: slugFromName(city.name) };
}

export function shortenName(city = {}) {
  const NEW_YORK = 7;
  const LOS_ANGELES = 1;
  const ORANGE_COUNTY = 15;
  const WASHINGTON_DC = 8;
  const SAN_FRANCISCO = 2;
  const LA_SOUTH_BAY = 14;

  switch (city.zone) {
    case NEW_YORK:
    case LOS_ANGELES:
    case WASHINGTON_DC:
    case SAN_FRANCISCO:
      return city.code;
    case ORANGE_COUNTY:
      return city.code.split('', 2).join('');
    case LA_SOUTH_BAY:
      return 'South Bay';
  }
  return city.name;
}
